import { render, staticRenderFns } from "./ExamManage.vue?vue&type=template&id=4dc3ce8f&scoped=true"
import script from "./ExamManage.vue?vue&type=script&lang=js"
export * from "./ExamManage.vue?vue&type=script&lang=js"
import style0 from "./ExamManage.vue?vue&type=style&index=0&id=4dc3ce8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc3ce8f",
  null
  
)

export default component.exports